// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"17545ac3","239":"f7cea6b2","453":"9ca50a21","455":"15f61960"}[chunkId] + ".chunk.js";
};